import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import { useParams } from 'react-router-dom';
import ModuleSettingsSupplierNotification from '@components/features/module-settings/supplier-notification/ModuleSettingsSupplierNotification.tsx';

interface ComponentProps {}

const ModuleSettingsSupplierNotificationPage: React.FC<ComponentProps> = () => {
  const { companyId } = useParams();

  if (!companyId) {
    return <></>;
  }

  return (
    <AdminLayout title={'Supplier notification module settings'}>
      <ModuleSettingsSupplierNotification companyId={companyId} />
    </AdminLayout>
  );
};

export default withAuthenticationRequired(ModuleSettingsSupplierNotificationPage);
